import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArchive1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="archive-1, inbox, file"><path d="M20.25 7.75V20.25H3.75V7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M2.75 3.75H21.25V7.75H2.75V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M10 11.75H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArchive1;
